<template>
  <div class="hidden md:block"><!-- Component wrapper -->

    <div v-if="cart == 0" class="flex flex-col items-center"><!--Main content-->

      <div :class="['w-[960px]', 'flex', 'mt-10', (j !== 0) ? 'border-t border-gamma-blue' : '',,(j == offers.length-1) ? 'border-b pb-5' : '']"
        v-for="(offer, j) in offers" :key="j"><!-- PRODUCT TILE-->

        <div class="w-[140px] mt-16">
          <img v-bind:src="require(`@/assets/images/${offer.img}`)" class="w-40 h-40">
        </div>

        <div class="w-[570px] flex flex-col mt-5 pl-4">
          <h1 class="text-center"> Opslagruimte {{ offer.short }} - {{ offer.size }}m<sup>3</sup></h1>
          <h4 class="text-gamma-grayA mt-2">ca. {{ offer.boxes }} verhuisdozen | {{ offer.sizeSquare }} m<sup>2</sup> |
            maximaal {{ offer.maxH }}m hoog</h4>
          <p class="mt-4">
            {{ offer.copy }}

          </p>

        </div>

        <div class="w-[250px] mt-5 flex flex-col items-center mt-14">
          <h2>€{{ Math.round(offer.price * 0.75) }} per maand</h2>
          <h4 class="text-sm ml-4 pl-6">Met gratis ophalen & bezorgen</h4>
          <button @click="selectSize(offer.size);"
            class="w-[180px] flex items-center bg-gamma-green rounded-2xl py-2 px-4 hover:shadow-2xl mt-5">

            <p class="text-white mx-auto">Reserveer online</p>

          </button>
          <div class="w-[180px] flex items-center bg-gamma-gray border border-gamma-blue rounded-xl p-2 mt-5">
            <img src="@/assets/images/avatar.png" class=" w-6 h-6 mr-2">
            <span class=" text-xs text-gamma-blue"><a
                href="https://meetings.hubspot.com/bram-meeting-link/gamma-opslagservice" target="_blank"> Hulp
                nodig met kiezen?</a></span>
          </div>
        </div>

      </div><!-- END PRODUCT TILE-->
    </div><!--END Main content-->
  </div><!-- Component wrapper -->
  <div class="md:hidden">
    <div v-if="cart==0" class="flex flex-col items-center"><!--Main content-->
      
      <div :class="['w-full', 'flex', 'flex-col', 'items-center', 'mt-10', 'border-t', 'border-gamma-blue' ,(j == offers.length-1) ? 'border-b pb-5' : '']" v-for="(offer,j) in offers" :key="j"><!-- PRODUCT TILE-->
        <h1 class="text-center mt-2"> Opslagruimte {{offer.short}} - {{offer.size}}m<sup>3</sup></h1>
         <h4 class="text-gamma-grayA mt-2">ca. {{offer.boxes}} verhuisdozen | {{offer.sizeSquare}} m<sup>2</sup> | maximaal {{offer.maxH}}m hoog</h4>
         <img v-bind:src="require(`@/assets/images/${offer.img}`)" class="w-40 h-40">

         <h2>€{{offer.price}} per maand</h2>
         <h4>v.a. gratis ophalen& bezorgen</h4>
         <button @click="selectSize(offer.size);" class="w-180 flex items-center bg-gamma-green rounded-2xl py-2 px-4 hover:shadow-2xl mt-5">
            
            <p class="text-white mx-auto">Meer informatie</p>

         </button>
         <div class="w-180 flex items-center bg-gamma-gray border border-gamma-blue rounded-xl p-2 mt-5">
                    <img src="@/assets/images/avatar.png" class=" w-6 h-6 mr-2">
                    <span class=" text-xs text-gamma-blue"><a href="https://meetings.hubspot.com/bram-meeting-link/gamma-opslagservice" target="_blank"> Hulp nodig met kiezen?</a></span>
                </div>    
        

      </div><!-- END PRODUCT TILE-->  

      

    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'New',
  components: {
  },
  data() {
    return {
      errors: [],
      cart: 0,
      travelCost: 0,

      plan: 'Doe het zelf - basic service',
      animation: false,
      phoneCode: '+31',

      spanSPone: false,
      spanSPtwo: false,
      spanSPthree: false,
      checkSPone: false,
      checkSPtwo: false,
      checkSPthree: false,

      totalES: 0,
      spanES: false,
      totalESPrice: 0,

      spanDriverHelp: false,
      checkDriverHelp: false,

      spanPakMaterial: false,
      checkPakMaterial: false,

      spanVerpakHulp: false,
      checkVerpakHulp: false,

      spanDemontage: false,
      checkDemontage: false,

      spanVerhuislift: false,
      checkVerhuislift: false,

      spanTussenStop: false,
      checkTussenStop: false,

      spanFilter: false,

      selectedCommitment: '12',
      selectedSize: '24',

      prefMoment: 0,
      pickupDate: '',

      klantBox: false,
      klantType: 'b2c',

      companyName: '',

      address: '',
      zip: '',
      fullName: '',
      lname: '',
      lnameError: '',
      email: '',
      phone: '',
      city: '',

      nameError: '',
      lnameError: '',
      emailError: '',
      phoneError: '',
      ophalError: '',
      zipError: '',
      cityError: '',

      link: '',
      finError: '',
      travel: '',
      refreshedOnce: false,

      travelTotal: 0,
      agreeOne: false,
      agreeTwo: false,
      agreeThree: false,
      mollieLink: '',

    }
  },
  computed: {
    ...mapState(['categoryData', 'commitments', 'categoriesAll', 'offers', 'submitData', 'currentOffer', 'controlLink', 'ip', 'detailsEntered', 'currentSizeData', 'travelCosts'])
  },
  mounted(){
    window.scrollTo({
        top: 0,
        behavior: "smooth" // Optional: for smooth scrolling effect
    });
  },
  methods: {
    ...mapMutations(['changeCheckoutSubmit', 'changeCheckoutData', 'editSize', 'changeSubmitData', 'changeCurrentStep', 'editCategory', 'changeLink', 'changeDetailsEntered', 'changeCurrentSizeData']),
    calculateDiscountPrice(price, commitment) {
      if (commitment < 3)
        return price;
      else if (commitment < 6)
        return Math.round(price * 0.95)
      else if (commitment < 12)
        return Math.round(price * 0.90)
      else if (commitment >= 12)
        return Math.round(price * 0.75)

    },
    calculateDiscount(commitment) {
      let price = this.currentOffer.price
      if (commitment < 3)
        return price;
      else if (commitment < 6)
        return Math.round(price * 0.95)
      else if (commitment < 12)
        return Math.round(price * 0.90)
      else if (commitment >= 12)
        return Math.round(price * 0.75)

    },
    // changeStep(step){

    // },
    scrollTo(id) {

      //document.getElementById(id).scrollIntoView();
      const yOffset = -300;
      const element = document.getElementById(id);
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    },

    changeKlant() {
      if (this.klantBox)
        this.klantType = 'b2b'
      else {
        this.klantType = 'b2c'
        this.companyName = ''
      }
    },
    chooseBasic() {
      this.checkSPone = true
      this.checkSPtwo = false
      this.changeSubmitData({ item: 'plan', new: 'Doe het zelf - basic service' })
      this.changeSubmitData({ item: 'planPrice', new: 0 })
    },
    choosePremium() {
      this.checkSPone = false
      this.checkSPtwo = true
      this.changeSubmitData({ item: 'plan', new: 'Do it for you - permium service' })
      this.changeSubmitData({ item: 'planPrice', new: this.currentOffer.premium })
    },
    selectPack(plan) {
      if (plan == "Doe het zelf - basic service")
        this.chooseBasic()
      else
        this.choosePremium()
    },
    selectCommitment(period) {
      this.selectedCommitment = period
      this.changeSubmitData({ item: 'commitment', new: this.selectedCommitment })
      this.changeTravelCosts()

    },
    async selectSize(size) {
      this.selectedSize = size
      this.editSize(size)
      this.changeSubmitData({ item: 'storage_size', new: this.selectedSize })
      if (this.checkSPtwo)
        this.choosePremium()
      else
        this.chooseBasic()

      this.editSize(size)

      await axios.get(`https://api-production.inboxstorage.eu/api/v1/control/size/getpost/${size}`).then((response) => {
        let data = response.data[0]
        this.changeCurrentSizeData({ item: 'size', new: size })
        this.changeCurrentSizeData({ item: 'lineOne', new: data.lineOne })
        this.changeCurrentSizeData({ item: 'lineTwo', new: data.lineTwo })
        this.changeCurrentSizeData({ item: 'lineThree', new: data.lineThree })
        this.changeCurrentSizeData({ item: 'lineFour', new: data.lineFour })
        this.changeCurrentSizeData({ item: 'paragraphOne', new: data.body })
        this.changeCurrentSizeData({ item: 'paragraphTwo', new: data.bodyMin })
        this.changeCurrentStep(1)
        this.$router.push({ name: 'Sizes' })
      }).catch(error => {

        console.log(error)
      });

    },
    changeTravelCosts() {
      console.log(this.travelCost)
      if (this.selectedCommitment == 1)
        this.travelTotal = this.travelCosts[this.travelCost].one
      if (this.selectedCommitment == 3)
        this.travelTotal = this.travelCosts[this.travelCost].three
      if (this.selectedCommitment == 6)
        this.travelTotal = this.travelCosts[this.travelCost].six
      if (this.selectedCommitment == 12)
        this.travelTotal = this.travelCosts[this.travelCost].twelve



    },
    getDayName(dateStr, locale) {
      var date = new Date(dateStr);
      return date.toLocaleDateString(locale, { weekday: 'long' });
    },
    getMonthName(dateStr, locale) {
      var date = new Date(dateStr);
      return date.toLocaleDateString(locale, { month: 'long' });
    },
    getDay(dateStr) {
      var date = new Date(dateStr);
      return date.getDate();
    },
    getPrefTime(moment) {
      if (moment == 0)
        return "08:00 - 19:00";
      if (moment == 1)
        return "08:00 - 12:00";
      if (moment == 2)
        return "12:00 - 16:00";
      if (moment == 3)
        return "08:00 - 10:00";
      if (moment == 4)
        return "Weekend";
    },
    sevenDays() {
      const date = new Date();
      date.setDate(date.getDate() + 7);
      var formatted_date = date.toJSON().slice(0, 10);
      return formatted_date
    },
    setPrefMoment(moment) {
      if (moment == 0) {
        this.changeSubmitData({ item: 'prefMoment', new: 'Dagplanning' })
        this.changeSubmitData({ item: 'prefMomentPrice', new: 0 })
      }
      if (moment == 1) {
        this.changeSubmitData({ item: 'prefMoment', new: 'Ochtendvak' })
        this.changeSubmitData({ item: 'prefMomentPrice', new: 20 })
      }
      if (moment == 2) {
        this.changeSubmitData({ item: 'prefMoment', new: 'Middagvak' })
        this.changeSubmitData({ item: 'prefMomentPrice', new: 20 })
      }
      if (moment == 3) {
        this.changeSubmitData({ item: 'prefMoment', new: 'DagStart' })
        this.changeSubmitData({ item: 'prefMomentPrice', new: 35 })
      }
      if (moment == 4) {
        this.changeSubmitData({ item: 'prefMoment', new: 'Weekend' })
        this.changeSubmitData({ item: 'prefMomentPrice', new: 50 })
      }
    },


    async submit() {
      this.finError = ""
      this.phoneError = ""
      this.ophalError = ""
      this.nameError = ""
      this.lnameError = ""
      this.emailError = ""
      this.zipError = ""
      this.cityError = ""
      if (!this.phone)
        this.phoneError = "Vul je telefoonnummer in"

      if (!this.address)
        this.ophalError = "Address is required"

      if (!this.fullName)
        this.nameError = "Vul je naam in"

      if (!this.lname)
        this.lnameError = "Vul je achternaam in"

      if (!this.email)
        this.emailError = "Vul je email in"

      if (!this.zip)
        this.zipError = "Vul je postcode in"

      if (!this.city)
        this.cityError = "Vul je woonplaats in"

      if (this.phoneError || this.ophalError || this.nameError || this.lnameError || this.emailError || this.zipError || this.cityError) {
        this.scrollTo(111)
        return;
      }

      if (!this.agreeOne || !this.agreeTwo || !this.agreeThree) {
        this.finError = "Vul alle velden in om de reservering compleet te maken"
        return;
      }


      if (this.klantType == 'b2b' && !this.companyName) {
        this.finError = "Company name required for Business client type"
        return;
      }
      this.changeSubmitData({ item: 'phone_number', new: this.phone })
      this.changeSubmitData({ item: 'oldPhone', new: this.phone })
      this.animation = true




      //HS STUFF
      let hubName = this.fullName
      let hubLname = this.lname
      let hubMail = this.email
      let hubPhone = this.phone
      let hubZip = this.zip
      let hubCity = this.city
      let hubCommitment = this.submitData.commitment
      let hubSize = this.submitData.storage_size
      let hubWhen = this.submitData.wanneer_opslagruimte_nodig
      let hubAddress = this.address
      let hubServiceType = this.submitData.plan
      let hubserviceplanprice = this.submitData.planPrice

      let hubDatum = this.pickupDate
      let hubMoment = this.prefMoment
      let hubCtype = this.klantType
      let hubBedrif = this.companyName

      let hubPrice = this.calculateDiscount(hubCommitment)
      let hubLink = this.link


      let hubQuotePriceOne = this.calculateDiscount(1)
      let hubQuotePriceTwo = this.calculateDiscount(3)
      let hubQuotePriceThree = this.calculateDiscount(6)
      let hubQuotePriceFour = this.calculateDiscount(12)
      let hubSquare_meters = this.currentOffer.sizeSquare * 1
      let hubBasic = this.travel
      let hubPremium = (this.currentOffer.premium * 1 + (this.travel / 1.4 * 1.9)).toFixed(2)
      let hubspotFields = [

        {
          'name': 'firstname',
          'value': hubName,
        },
        {
          'name': 'lastname',
          'value': hubLname,
        },
        {
          'name': 'email',
          'value': hubMail,
        },
        {
          'name': 'zip',
          'value': hubZip,
        },

        {
          'name': 'aantal_kuub',
          'value': hubSize,
        },
        {
          'name': 'when_storage_required02',
          'value': hubWhen,
        },
        {
          'name': 'city',
          'value': hubCity,
        },
        {
          'name': 'address',
          'value': hubAddress,
        },
        {
          'name': 'serviceType',
          'value': hubServiceType,
        },
        {
          'name': 'serviceplanprice',
          'value': hubserviceplanprice,
        },

        {
          'name': 'travelCosts',
          'value': this.travelTotal,
        },

        {
          'name': 'phone',
          'value': hubPhone,
        },
        {
          'name': 'commitment',
          'value': hubCommitment,
        },
        {
          'name': 'pref_date',
          'value': hubDatum,
        },
        {
          'name': 'voorkeursmoment',
          'value': hubMoment,
        },
        {
          'name': 'klanttype',
          'value': hubCtype,
        },
        {
          'name': 'company',
          'value': hubBedrif,
        },


      ];
      let data = {}
      data['context'] = {
        'pageUri': 'https://inboxstorage.eu/commitment',
        'pageName': 'Commitment',

      }
      data['fields'] = hubspotFields
      if (!this.disableHubspot) {
        axios.post('https://api.hsforms.com/submissions/v3/integration/submit/1979474/2b4d8223-0fc8-4431-9495-29d330ab1cf1', data)
          .then((response) => {
            let res = response.data
            //this.$router.push({path: '/thankyou'})
            this.animation = false
            this.changeDetailsEntered(2)



          }).catch(error => {
            console.log(error)
          });
      }
      await axios.get('https://shop.inboxstorage.eu/api/onetimepayment').then((response) => {


        //console.log(response.data)
        //window.location.href = response.data.link
        //this.$router.push({path: response.data.link})

        this.mollieLink = response.data.link
        this.cart = 3
        window.open(this.mollieLink)



      }).catch(error => {
        this.ICError = error
        this.animation = false
        console.log(error)
      });
      //END HS STUFF

    },//END submit()
    getCommitmentTitle(commitment) {
      if (commitment == 1)
        return "1+ maand";
      if (commitment == 3)
        return "3+ maanden";
      if (commitment == 6)
        return "6+ maanden";
      if (commitment == 12)
        return "12+ maanden";
    },
    getPlan() {
      return this.submitData.plan
    },
    getPlanPrice() {
      return this.submitData.planPrice
    },
    getTotalES() {
      return this.submitData.totalES
    },
    getESPrice() {
      return this.submitData.totalESPrice
    },
    getPrefMoment() {
      return this.submitData.prefMoment
    },
    getPrefMomentPrice() {
      return this.submitData.prefMomentPrice
    },
    getPrefDate() {
      return this.submitData.prefDate
    },
  },
  created() {
    this.pickupDate = this.sevenDays()
    this.changeSubmitData({ item: 'prefDate', new: this.pickupDate })

  }
}
</script>
<style scoped>
.w-180{
  width:190px
}
</style>